<template>
  <form id="payment-info" class="stax-payment-form" @submit.prevent>
    <div class="field-row">
      <div class="field-label">
        <p class="field-title">Card Number</p>
        <p class="field-required">(Required)</p>
      </div>
      <div :id="`card-number-${tab}`" :placeholder="'Credit card number'" class="field-shell field-shell-card flex" />
    </div>

    <div class="field-row">
      <div class="field-label">
        <p class="field-title">Cardholder Name</p>
        <p class="field-required">(Required)</p>
      </div>
      <div class="field-shell field-shell-input">
        <input v-model="cardholderName" placeholder="Cardholder Name" class="payment-input" />
      </div>
    </div>

    <div class="split-fields-row">
      <div class="field-label">
        <p class="field-title">Expiration Date</p>
        <p class="field-required">(Required)</p>
      </div>
      <div class="field-shell field-shell-input">
        <input v-model="expireDate" placeholder="MM/YYYY" class="payment-input" />
      </div>

      <div class="field-label split-label">
        <p class="field-title">CVV</p>
        <p class="field-required">(Required)</p>
      </div>
      <div :id="`card-cvv-${tab}`" class="field-shell field-shell-cvv" />
    </div>

    <div class="field-row">
      <div></div>
      <div
        v-if="showSaveCard"
        id="save-card-future-use"
        class="flex cursor-pointer items-center"
        @click="isSaveCard = !isSaveCard"
      >
        <span class="material-icons-outlined check-box">
          {{ isSaveCard ? "check_box" : "check_box_outline_blank" }}
        </span>
        <p>Save card for future use</p>
      </div>
    </div>

    
    <div class="action-row">
      <NewLibraryButton
        v-if="showBackButton"
        color-type="dark-blue-stroke"
        class="action-back-btn"
        @click="cancelPayment"
      >
        Back
      </NewLibraryButton>
      <button
        :id="`tokenizebutton-${tab}`"
        v-loading.lock="loading"
        type="button"
        :class="[
          'tokenize-btn',
          isBottom ? 'bottom-fixed' : '',
          showBackButton ? 'with-back-button' : 'full-width'
        ]"
      >
        {{ mode === "payment" ? `Complete Payment ${currency.symbol + chargeAmount.toFixed(2)}` : 'Save Card' }}
      </button>
    </div>
  </form>
</template>

<script>
import NewLibraryButton from "@/NewLibrary/Button.vue";
import { getStaxKeyApi, savePaymentApi } from "@/api/va-order-page/newChargingService";
import { notify } from '@/utils/notify';

export default {
  components: {
    NewLibraryButton
  },
  props: {
    /*
     * for customer pay:
       cardHolderDetails = {
         customer_id: customerStaxIdToken(String)
       }
     * for patient pay now:
        cardHolderDetails = {
          phone: String,
          address_1: String,
          address_city: String,
          address_state: String
        }
     * 
     */
    cardHolderDetails: {
      type: Object,
      default: () => {}
    },
    chargeItemCount: {
      type: Number,
      default: 0
    },
    chargeAmount: {
      type: Number,
      default: 0
    },
    showSaveCard: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    currency: {
      type: Object,
      default: () => ({ name: "USD", symbol: "$"})
    },
    tab: {
      type: String,
      default: "client"
    },
    mode: {
      type: String,
      default: "payment"
    },
    accountId: {
      type: Number,
      required: true
    },
    accountType: {
      type: String,
      required: true
    },
    clinicId: {
      type: Number,
      default: null
    }
  },
  emits: ["tokenize", "cancelPayment"],
  data() {
    return {
      cardholderName: "",
      expireDate: "",
      validNumber: false,
      validCvv: false,
      isSaveCard: false,
      loading: false
    }
  },
  computed: {
    isBottom() {
      return document.location.href.includes('/ordertest') 
        && !document.location.href.includes('order-center');
    }
  },
  watch: {
    expireDate(newVal, oldVal) {
      if (newVal.length === 0) return;
      let curInput = newVal[newVal.length - 1];
      const regex = /[0-9]/;
      // delete user current input if it is not a number (need deal with '/')
      if (!curInput.match(regex)) {
        if (curInput === "/") {
          if (newVal.length !== 3)
            this.expireDate = this.expireDate.slice(0, -1);
        } else this.expireDate = this.expireDate.slice(0, -1);
      } else {
        // autofill the "/" between month&year
        if (oldVal.length === 1 && newVal.length === 2)
          this.expireDate += "/";
      }
    },
  },

  mounted() {
    this.stax();
  },

  methods: {
    //STAX payment
    // reference: https://docs.paywithomni.com/pay-with-card-website/
    async stax() {
      // get webtoken
      const { data } = await getStaxKeyApi();
      let token = data.stax_key;
      var tokenizeButton = document.querySelector(`#tokenizebutton-${this.tab}`);
      const StaxJs = window.StaxJs;
      // Init FattMerchant API
      // let buff = Buffer.from("VmlicmFudC1XZWxsbmVzcy02NjRkM2ZmYzVkYmE=", "base64");
      // let token = buff.toString("ascii");
      var staxJs = new StaxJs(token, {
        number: {
          id: `card-number-${this.tab}`,
          placeholder: "0000-0000-0000-0000",
          style:
            "height: 19px; font-size: 16px; letter-spacing: 0.15px; line-height: 19px; width: 100%; color: #000000",
          format: "prettyFormat",
        },
        cvv: {
          id: `card-cvv-${this.tab}`,
          placeholder: "CVV",
          style:
            "height: 19px; font-size: 16px; letter-spacing: 0.15px; line-height: 19px; width: 100%; color: #000000",
        },
      });
      // tell staxJs to load in the card fields
      staxJs
        .showCardForm()
        .then((handler) => {
          // console.log("form loaded");
          // console.log(handler);
        })
        .catch((err) => {
          console.log("error init form " + err);
        });

      staxJs.on("card_form_complete", (message) => {
        tokenizeButton.disabled = false;
        // this.isPaymentDisabled = true;
        // console.log(message);
        this.validNumber = message.validNumber;
        this.validCvv = message.validCvv;
      });

      staxJs.on("card_form_incomplete", (message) => {
        // tokenizeButton.disabled = true;
        // this.isPaymentDisabled = false;
        // console.log(message)
        this.validNumber = message.validNumber;
        this.validCvv = message.validCvv;
      });

      document.querySelector(`#tokenizebutton-${this.tab}`).onclick = async () => {
        // no ordered items
        if (this.chargeItemCount === 0) {
          let message = "Must order at least one test";
          notify({ type: 'error', message }); 
          return;
        }

        if (this.mode === "payment") {
          if (this.chargeAmount === 0) {
            this.$emit("tokenize", { staxToken: { id: null }, isSaveCard: this.isSaveCard });
            return;
          }
        }

        // invalid card number or cvv
        if (!this.validNumber) {
          notify({ type: 'error', title: 'Failed', message: 'Invalid card number.' });
          return;
        }
        if (!this.validCvv) {
          let message = "Invalid cvv.";
          notify({ type: 'error', message }); 
          return;
        }
        this.loading = true;
        let [expMonth, expYear] = this.expireDate.split("/");
        let [firstName, lastName] = this.cardholderName.split(" ");
        var extraDetails = {
          ...this.cardHolderDetails,
          firstname: firstName,
          lastname: lastName,
          month: expMonth,
          year: expYear,
          method: "card",
        };
        // call tokenize api when finalOrderPrice > 0
        staxJs.tokenize(extraDetails)
        .then(async (result) => {
          // console.log("tokenize:");
          // console.log(result);
          if (this.isSaveCard || this.mode !== "payment") {
            try {
              await savePaymentApi({
                account_id: this.accountId,
                account_type: this.accountType,
                clinic_id: this.accountType === "customer" ? this.clinicId : null,
                type: "card",
                token_platform: "stax",
                payment_token: result.id,
                is_default: false,
                card_type: result.card_type || "",
                last_four: result.card_last_four || "",
                expiry_date: result.card_exp || "",
                nick_name: "",
                is_subscription: false,
                customer_token: this.cardHolderDetails.customer_id
              });
            } catch (err) {
              console.error("save stax payment error:", err);
            }
          }
          this.loading = false;
          this.$emit("tokenize", { 
            staxToken: { ...result, payment_token: result.id }, 
            isSaveCard: this.isSaveCard 
          });
        })
        .catch(err => {
          console.log(err)
          let message = err.phone 
            ? err.phone[0]
            : err.address_state
            ? err.address_state[0]
            : err.message && err.message.includes("Request failed with status code") 
            ? "Payment fails. Please check your credit card information and retry." 
            : err.message;
          notify({ type: 'error', message }); 
          this.loading = false;
        });
      };
    },

    cancelPayment() {
      this.$emit("cancelPayment");
    }
  }
}
</script>

<style scoped>
.stax-payment-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field-row {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: start;
  column-gap: 24px;
}

.split-fields-row {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) 90px minmax(0, 1fr);
  column-gap: 24px;
  align-items: start;
}

.field-label {
  padding-top: 4px;
  text-align: right;
}

.field-title,
.field-required {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 18px;
}

.field-title {
  color: #4a4a4a;
  font-weight: 400;
}

.field-required {
  color: #d10000;
  font-weight: 700;
}

.split-label {
  min-width: 0;
}

.field-shell {
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  min-height: 44px;
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  background: #ffffff;
}

.field-shell-input {
  display: flex;
  align-items: center;
  padding: 0 12px;
}

.field-shell-card {
  display: flex;
  align-items: center;
  overflow: hidden;
  height: 44px;
  padding-top: 10px;
  padding-left: 12px;
}

.field-shell-cvv {
  overflow: hidden;
  height: 44px;
  padding: 13px 16px 0;
}

.credit-card {
  color: #c9cacd;
  margin-right: 12px;
  font-size: 24px;
}

.check-box {
  color: rgba(0, 0, 0, 0.26);
  margin-right: 12px;
}

.action-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.action-back-btn {
  flex-shrink: 0;
  width: 97px;
}

.with-back-button {
  width: calc(100% - 113px);
}

.full-width {
  width: 100%;
}

.tokenize-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 40px;
  padding: 8px 32px;
  border-radius: 4px;
  border: none;
  background: var(--VibrantDarkBlue, #004879);
  color: #ffffff;
  font-family: "IBM Plex Sans Hebrew", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.25px;
  transition: background-color 0.5s ease, color 0.5s ease;
  cursor: pointer;
}

.tokenize-btn:hover {
  background: #20A7C1;
}

.tokenize-btn:active {
  background: #5587BC;
}

.tokenize-btn:disabled {
  background: #b0b0b0;
  cursor: not-allowed;
}

.payment-input {
  width: 100%;
  height: 28px;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #000000;
  font-family: "IBM Plex Sans Hebrew", sans-serif;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0.15px;
}

.payment-input::placeholder {
  color: #999999;
  opacity: 1;
}

.bottom-fixed {
  position: fixed;
  bottom: 89px; 
  z-index: 1000; 
  width: 373px;
  height: 42px;
  right: 52px;
}
</style>